var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M3.26325 3.6275C3.267 3.623 3.2685 3.617 3.27225 3.6125L5.89032 0.71995C6.03656 0.557212 6.03656 0.29323 5.89032 0.130491C5.88882 0.128991 5.88732 0.128241 5.88582 0.127491C5.85328 0.0880855 5.81253 0.05626 5.76642 0.0342391C5.72031 0.0122182 5.66994 0.000532984 5.61884 0H0.381949C0.329912 0.000840853 0.278693 0.0130976 0.231913 0.0359048C0.185132 0.058712 0.14393 0.0915132 0.111217 0.131991L0.109718 0.130491C0.0389451 0.212375 0 0.316991 0 0.425221C0 0.533451 0.0389451 0.638067 0.109718 0.71995L2.73379 3.6275C2.76645 3.66579 2.80704 3.69654 2.85275 3.71763C2.89845 3.73872 2.94818 3.74963 2.99852 3.74963C3.04885 3.74963 3.09859 3.73872 3.14429 3.71763C3.19 3.69654 3.23058 3.66579 3.26325 3.6275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.92edd20e5db9ed25d9e9c96dcf7e2af0.svg";
export { ForwardRef as ReactComponent };